import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStyles } from './styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import MapIcon from '@mui/icons-material/Map';
import ContactForm from '../contactForm/ContactForm';

const Contact = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const styles = getStyles(isRtl);

  const locations = [
    {
      name: "Head Office",
      address: "Villa No. 168, Sultan Pasha Street - Al-Nawadi District - New Al Minya, Egypt.",
      coords: "https://maps.app.goo.gl/bmNUSha6KpANZcS57",
      phone: "Tel: (+2) 086 – 2240022 Mob: (+2) 01067635311"
    },
     {
      name: 'Cairo Office',
      address: "98 al Amal buildings, Al Autostrad Road Al Maadi, Cairo, Egypt.",
      coords: "https://maps.app.goo.gl/uyggPJ9ivsKyKC5y5",
      phone: 'Tel: (+2)-227004835 Mob:(+2) 01090774575'
    },
    {
      name: "Factory",
      address: "Industrial Zone, Al Matahra, Al Minya, Egypt.",
      coords: "https://maps.app.goo.gl/MxhLfDt597nDEBxy7",
      phone: "Mob:(+2) 01090774575"
    },
   {
      name: "Quarry",
      address: "kilo 5 - Minya Road, eastern Beni Suef, Egypt.",
      coords: "https://maps.app.goo.gl/MxhLfDt597nDEBxy7",
      phone: "Mob:(+2) 01090774575"
    }
  ];

  const getMapUrl = (location) => `https://www.google.com/maps/dir/?api=1&destination=${location.query}`;
  
  const getStaticMapUrl = (location) => {
    return `https://maps.googleapis.com/maps/api/staticmap?center=${location.coords}&zoom=15&size=400x200&markers=color:red%7C${location.coords}&scale=2&style=feature:road|color:0xffffff&style=feature:landscape|color:0xf5f5f5&style=feature:water|color:0xe6e6e6`;
  };

  const MapImage = ({ location, alt }) => (
    <div style={styles.mapImageContainer}>
      <a 
        href={`https://www.google.com/maps?q=${location.coords}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img 
          src={getStaticMapUrl(location)} 
          alt={alt}
          style={styles.mapImage}
        />
        <div style={styles.mapOverlay}>
          <MapIcon style={styles.mapOverlayIcon} />
          <span style={styles.mapOverlayText}>View Map</span>
        </div>
      </a>
    </div>
  );

  return (
    <div style={styles.contact}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>{t('navigation.contact')}</h1>
      </div>

      <div style={styles.contactInfoSection}>
        <div style={styles.contactGrid}>

          {locations.map((item) => {
            return(
            <div style={styles.contactCard}>
              <h3 style={{...styles.contactCardH3, color: 'rgb(154,74,32)'}}>
                <LocationOnIcon style={styles.icon} />
                {item.name}
              </h3>
              <p style={{...styles.contactCardP, color: '#7f6001',}}>{item.address}</p>

              <div style={styles.contactInfo}>
                <p style={{...styles.contactCardPhone,color: '#7f6001',}}>
                  <PhoneIcon style={styles.icon} />
                  {item.phone}
                </p>
                {/* <MapImage location={locations.headOffice} alt="Head Office Location" /> */}
                {/* <a 
                  href={getMapUrl(locations.headOffice)} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={styles.mapLink}
                >
                  <LocationOnIcon style={styles.icon} />
                  {t('contact.getDirections')}
                </a> */}
              </div>
            </div>
            )
          })}


        </div>
      </div>

      <div style={{marginTop: '100px'}}>

        <ContactForm />
      </div>
    </div>
  );
};

export default Contact; 